/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { EquipmentTypesService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    TypeEntityTypes,
} from '@pf/shared-common';
import { EquipmentTypeStore } from './equipment-type.store';
import {
    EquipmentTypeCreate,
    EquipmentTypeRead,
    EquipmentTypeSearchParams,
} from '../../entities/equipment-type.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class EquipmentTypeDataService extends AbstractDataService<
    EquipmentTypeRead,
    EquipmentTypeCreate
> {
    protected EntityName = TypeEntityTypes.WarehouseEquipmentType;
    constructor(
        private service: EquipmentTypesService,
        store: EquipmentTypeStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: EquipmentTypeCreate
    ): Observable<EquipmentTypeRead> {
        return this.service.equipmentTypeCreate({
            equipmentTypeViewModelCreateBody: body,
        }) as Observable<EquipmentTypeRead>;
    }
    protected deleteObs$(id: string): Observable<EquipmentTypeRead> {
        return this.service.equipmentTypeDelete({
            id,
        }) as Observable<EquipmentTypeRead>;
    }
    protected undoDeleteObs$(id: string): Observable<EquipmentTypeRead> {
        return this.service.equipmentTypeUndoDelete({
            id,
        }) as Observable<EquipmentTypeRead>;
    }
    protected getObs$(id: string): Observable<EquipmentTypeRead> {
        return this.service.equipmentTypeReadById({
            id,
        }) as Observable<EquipmentTypeRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<EquipmentTypeRead> {
        return this.service.equipmentTypeUpdatePatch({
            id,
            operation: operations,
        }) as Observable<EquipmentTypeRead>;
    }
    protected searchObs$(
        searchParams: EquipmentTypeSearchParams
    ): Observable<IPagedResult<EquipmentTypeRead>> {
        return this.service.equipmentTypeSearch(searchParams) as Observable<
            IPagedResult<EquipmentTypeRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<EquipmentTypeRead>>> {
        return this.service.equipmentTypeGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<EquipmentTypeRead>>
        >;
    }
}
